<template>
  <div class="widthContent">
    <PageBanner url="https://www.yueyilan.com/img-yueyilan/upload/photo/zsyf/yanglao.png" title="养老百科"/>
    <router-view></router-view>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner'
export default {
  name: 'index',
  components:{
    PageBanner
  }
}
</script>





// WEBPACK FOOTER //
// src/components/Encyclopedia/index.vue